import React from "react"

import { jewlr_t } from "helpers/application"

export const banner = () => ({
  image: {
    alt: "Personalized Watches",
    fallback: `${sl.config.jewlr_asset_url}images/info/watches/landing/mainbanner/desktop_2x.jpg`,
    srcSet: [
      {
        media: "(max-width: 767px)",
        sizes: "100vw",
        srcSet: `${sl.config.jewlr_asset_url}images/info/watches/landing/mainbanner/mobile.jpg 767w,
                  ${sl.config.jewlr_asset_url}images/info/watches/landing/mainbanner/mobile_2x.jpg 1534w`,
      },
      {
        media: "(min-width: 768px) and (max-width: 1023px)",
        sizes: "100vw",
        srcSet: `${sl.config.jewlr_asset_url}images/info/watches/landing/mainbanner/tablet.jpg 1024w,
                  ${sl.config.jewlr_asset_url}images/info/watches/landing/mainbanner/tablet_2x.jpg 2048w`,
      },
      {
        media: "(min-width: 768px)",
        sizes: "100vw",
        srcSet: `${sl.config.jewlr_asset_url}images/info/watches/landing/mainbanner/desktop.jpg 1920w,
                  ${sl.config.jewlr_asset_url}images/info/watches/landing/mainbanner/desktop_2x.jpg 3840w`,
      },
    ],
    style: { width: "100vw" },
  },
  style: { pb: { _: "43.42%", tablet: "30.57%" } },
  textarea: {
    style: {
      left: "5%",
      style: { transform: "translateY(-50%)" },
      top: "50%",
      width: "180px",
    },
    texts: [
      {
        style: {
          color: "black",
          fontSize: { _: 30, tablet: 35 },
          fontWeight: 700,
        },
        text: `${jewlr_t("terms.Personalized")} Watches`,
        type: "title",
      },
    ],
  },
})

export const features = () => [
  {
    content: {
      ContentStyle: {
        mb: { _: 0, tablet: 5 },
      },
      description:
        "Our watches are made using Japan quartz movement and feature water-resistant stainless steel cases, case backs, and crowns. All our styles are verified for accuracy and authenticity.",
      descriptionStyle: { px: { _: 5, desktop: "80px", tablet: 2 } },
      position: "left",
      title: "Quality-Crafted Just For You",
    },
    image: {
      desktop: `${sl.config.jewlr_asset_url}images/info/watches/landing/quality-crafted.jpg`,
      desktop_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/quality-crafted-2x.jpg`,
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/landing/quality-crafted.jpg`,
      mobile: `${sl.config.jewlr_asset_url}images/info/watches/landing/quality-crafted-mobile.jpg`,
      mobile_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/quality-crafted-mobile-2x.jpg`,
      style: { mb: 3, width: "85%" },
    },
    links: {
      base_style: "underline",
      color: "primary",
      text: "Shop All Watches",
      url: "/all-watch-collection",
    },
  },
  {
    content: {
      ContentStyle: {
        mb: { _: 0, tablet: 5 },
      },
      description: `Choose the perfect strap to suit your unique style. All our watches are available with a choice of quality strap options and ${jewlr_t(
        "terms.color"
      )}s.`,
      descriptionStyle: { px: { _: 4, desktop: "100px", tablet: 5 } },
      position: "right",
      title: "Watch Straps",
    },
    image: {
      desktop: `${sl.config.jewlr_asset_url}images/info/watches/landing/watch-straps.jpg`,
      desktop_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/watch-straps-2x.jpg`,
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/landing/watch-straps.jpg`,
      mobile: `${sl.config.jewlr_asset_url}images/info/watches/landing/watch-straps-mobile.jpg`,
      mobile_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/watch-straps-mobile-2x.jpg`,
      style: { mb: 3, width: "85%" },
    },
    links: {
      base_style: "underline",
      color: "primary",
      text: "Shop All Watches",
      url: "/all-watch-collection",
    },
  },
  {
    content: {
      ContentStyle: {
        mb: { _: 0, tablet: 5 },
      },
      description: `Your watch arrives in our elegant black box, ready to give. You can also add a ${jewlr_t(
        "terms.personalized"
      )} gift message and create a one-of-a-kind keepsake photo box.`,
      descriptionStyle: { px: 7 },
      position: "right",
      title: "Packaged For Gifting",
    },
    image: {
      desktop: `${sl.config.jewlr_asset_url}images/info/watches/landing/packaged_for_gifting.png`,
      desktop_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/packaged_for_gifting_2x.png`,
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/landing/packaged_for_gifting.png`,
      mobile: `${sl.config.jewlr_asset_url}images/info/watches/landing/packaged_for_gifting_mobile.jpg`,
      mobile_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/packaged_for_gifting_mobile_2x.jpg`,
    },
    wrapperStyle: { display: { tablet: "none" } },
  },
]

export const makeItPersonal = () => [
  {
    BoxStyle: {
      width: {
        _: "80%",
        desktop: "63%",
        tablet: "87%",
        widescreen: "46%",
      },
    },
    content: {
      ContentStyle: {
        mb: { _: 0, tablet: 5 },
        mr: { tablet: 2 },
        textAlign: { tablet: "left" },
      },
      description: (
        <>
          Choose your case, choose your strap,
          <br />
          add your engraving.
        </>
      ),
      descriptionMobile:
        "Choose your case, choose your strap, add your engraving.",
      descriptionMobileStyle: {
        display: { tablet: "none" },
        px: 5,
      },
      descriptionStyle: {
        display: { _: "none", tablet: "block" },
      },
      title: "It’s Your Time... Make It Personal",
      titleStyle: {
        mx: "auto",
        width: { _: "60%", tablet: "100%" },
      },
    },
    image: {
      desktop: `${sl.config.jewlr_asset_url}images/info/watches/landing/watch-make-it-personal.jpg`,
      desktop_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/watch-make-it-personal.jpg`,
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/landing/watch-make-it-personal.jpg`,
      mobile: `${sl.config.jewlr_asset_url}images/info/watches/landing/watch-make-it-personal.jpg`,
      mobile_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/watch-make-it-personal.jpg`,
      style: {
        mb: 3,
        width: { _: "170px", tablet: "200px" },
      },
    },
    links: {
      base_style: "button",
      bg: "primary",
      color: "white",
      display: "inline-block",
      padding: "10px 25px",
      text: "Start Creating Yours",

      url: "/all-watch-collection",
    },
    video: {
      poster: "watches_website_gif_desktop_thumb.png",
      url: "watches_website_gif_desktop.mp4",
    },
  },
]

export const watchCollections = () => [
  {
    image: {
      desktop: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      desktop_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      mobile: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      mobile_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/mens-watches.png`,
      style: {
        mb: 1,
      },
    },
    links: {
      base_style: "button",
      bg: "primary",
      color: "white",
      display: "inline-block",
      padding: "10px 50px",
      text: "Shop Men's",
      url: "/all-mens-watches",
    },
  },
  {
    image: {
      desktop: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo.png`,
      desktop_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo_2x.png`,
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo_2x.png`,
      mobile: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo.png`,
      mobile_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/womens-watches-combo_2x.png`,
      style: {
        mb: 1,
      },
    },
    links: {
      base_style: "button",
      bg: "primary",
      color: "white",
      display: "inline-block",
      padding: "10px 50px",
      text: "Shop Women's",
      url: "/all-womens-watches",
    },
  },
]

export const shopAllWatches = () => [
  {
    content: {
      description: (
        <>
          Unique styles with a choice of custom
          <br /> options – crafted just for you.
        </>
      ),
      position: "right",
      title: `${jewlr_t("terms.Personalize")} Your Watch Today`,
    },

    image: {
      desktop: `${sl.config.jewlr_asset_url}images/info/watches/landing/shop_all_desktop.jpg`,
      desktop_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/shop_all_desktop_2x.jpg`,
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/landing/shop_all_desktop.jpg`,
      mobile: `${sl.config.jewlr_asset_url}images/info/watches/landing/shop_all_mobile.jpg`,
      mobile_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/shop_all_mobile_2x.jpg`,
      style: {
        mb: 3,
        ml: { desktop: "60px" },
        width: { _: "385px", tablet: "500px" },
      },
    },

    links: {
      base_style: "button",
      bg: "primary",
      color: "white",
      display: "inline-block",
      padding: "10px 50px",
      text: "Shop All Watches",
      url: "/all-watch-collection",
    },
  },
]

export const packagedForGifting = () => [
  {
    BoxStyle: {
      height: { desktop: "336px", tablet: "228px" },
      mb: 6,
    },
    content: {
      description: `Your watch arrives in our elegant black box, ready to give. You
      can also add a ${jewlr_t("terms.personalized")} gift message
      and create a one-of-a-kind keepsake photo box.`,
      descriptionStyle: { margin: "auto", width: "70%" },
      position: "left",
      title: "Packaged For Gifting",
    },

    image: {
      desktop: `${sl.config.jewlr_asset_url}images/info/watches/landing/packaged_for_gifting.png`,
      desktop_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/packaged_for_gifting_2x.png`,
      fallback: `${sl.config.jewlr_asset_url}images/info/watches/landing/packaged_for_gifting.png`,
      mobile: `${sl.config.jewlr_asset_url}images/info/watches/landing/packaged_for_gifting_mobile.jpg`,
      mobile_2x: `${sl.config.jewlr_asset_url}images/info/watches/landing/packaged_for_gifting_mobile_2x.jpg`,
      style: {
        mt: { desktop: "82px", tablet: "56px" },
        pr: 6,
        width: { _: "385px", tablet: "500px" },
      },
    },
    wrapperStyle: {
      bg: "polar",
      display: { _: "none", tablet: "block" },
      height: { desktop: "336px", tablet: "228px" },
      mb: "70px",
    },
  },
]

export const stepData = [
  { img: "one", text: "Choose Your Case" },
  { img: "two", text: "Choose Your Strap" },
  { img: "three", text: "Add Your Engraving" },
]

export const watchesForMen = [
  {
    folder: "JWAT01-32-BKBK-BKMSH",
    link: "/products/JWAT01-32-BKBK-BKMSH",
    text: "Shop Now",
    title: "Men's 32mm Dress Watch - Black Case, Black Dial, Black Mesh",
  },
  {
    folder: "JWAT02-38-STBL-STS",
    link: "/products/JWAT02-38-STBL-STS",
    text: "Shop Now",
    title: "Men's 38mm Sport Watch - Steel Case, Blue Dial, Steel Link",
  },
  {
    folder: "JWAT01-36-STWT-BLK",
    link: "/products/JWAT01-36-STWT-BLK",
    text: "Shop Now",
    title: "Men's 36mm Dress Watch - Steel Case, White Dial, Black Leather",
  },
  {
    folder: "JWAT03-40-BKBK-BKNT",
    link: "/products/JWAT03-40-BKBK-BKNT",
    text: "Shop Now",
    title: "Men's 40mm Dress Watch - Black Case, Black Dial, Black Nato",
  },
  {
    folder: "JWAT01-32-YGBK-YGMSH",
    link: "/products/JWAT01-32-YGBK-YGMSH",
    text: "Shop Now",
    title: "Men's 32mm Dress Watch - Gold Case, Black Dial, Gold Mesh",
  },
  {
    folder: "JWAT01-32-STWT-BRN",
    link: "/products/JWAT01-32-STWT-BRN",
    text: "Shop Now",
    title: "Men's 32mm Dress Watch - Steel Case, White Dial, Brown Leather",
  },
  {
    folder: "JWAT03-40-YGWT-GRN",
    link: "/products/JWAT03-40-YGWT-GRN",
    text: "Shop Now",
    title: "Men's 40mm Dress Watch - Gold Case, White Dial, Green Leather",
  },
  {
    folder: "JWAT02-38-YGBK-YG",
    link: "/products/JWAT02-38-YGBK-YG",
    text: "Shop Now",
    title: "Men's 38mm Sport Watch - Gold Case, Black Dial, Two-Tone Link",
  },
]

export const watchesForWomen = [
  {
    folder: "JWAT04-36-RGWT-RGMSH",
    link:
      "/products/JWAT04-36-RGWT-RGMSH/women's-personalized-36mm-dress-watch-rose-gold-case-white-dial-rose-mesh",
    text: "Shop Now",
    title: "Women's 36mm Dress Watch",
  },
  {
    folder: "JWAT04-32-YGWT-GCROC",
    link:
      "/products/JWAT04-32-YGWT-GCROC/women's-personalized-32mm-dress-watch-gold-case-white-dial-grey-croc-leather",
    text: "Shop Now",
    title: "Women's 32mm Dress Watch",
  },
  {
    folder: "JWAT04-32-RGBK-BURG",
    link:
      "/products/JWAT04-32-RGBK-BURG/women's-personalized-32mm-dress-watch-rose-gold-case-black-dial-burgundy-leather",
    text: "Shop Now",
    title:
      "Women's 32mm Dress Watch - Rose Gold Case, Black Dial, Burgundy Leather",
  },
  {
    folder: "JWAT04-36-YGWT-YGMSH",
    link:
      "/products/JWAT04-36-YGWT-YGMSH/women's-personalized-36mm-dress-watch-gold-case-white-dial-gold-mesh",
    text: "Shop Now",
    title:
      "Women's Personalized 36mm Dress Watch - Gold Case, White Dial, Gold Mesh",
  },
  {
    folder: "JWAT04-36-BKBK-BKMSH",
    link:
      "/products/JWAT04-36-BKBK-BKMSH/women's-personalized-36mm-dress-watch-black-case-black-dial-black-mesh",
    text: "Shop Now",
    title:
      "Women's Personalized 36mm Dress Watch - Black Case, Black Dial, Black Mesh",
  },
  {
    folder: "JWAT05-40-PSTBK-LGRY",
    link:
      "/products/JWAT05-40-PSTBK-LGRY/women's-personalized-40mm-dress-watch-polished-steel-case-black-dial-silver-leather",
    text: "Shop Now",
    title:
      "Women's Personalized 40mm Dress Watch - Polished Steel Case, Black Dial, Silver Leather",
  },
  {
    folder: "JWAT05-40-RGBK-BLU",
    link:
      "/products/JWAT05-40-RGBK-BLU/women's-personalized-40mm-dress-watch-rose-case-black-dial-blue-leather",
    text: "Shop Now",
    title:
      "Women's Personalized 40mm Dress Watch - Rose Case, Black Dial, Blue Leather",
  },
  {
    folder: "JWAT05-40-PSTBK-BLK",
    link:
      "/products/JWAT05-40-PSTBK-BLK/women's-personalized-40mm-dress-watch-polished-steel-case-black-dial-black-leather",
    text: "Shop Now",
    title:
      "Women's Personalized 40mm Dress Watch - Polished Steel Case, Black Dial, Black Leather",
  },
]

export const shopByStyle = [
  {
    folder: "JWAT01-36-STWT-MSH",
    link: "/mens-dress-watches",
    text: "Shop Dress Watches",
    title: "Men's 40mm Field Watch - Steel Case, Black Dial, Tan Leather",
  },
  {
    folder: "JWAT03-40-STBKF-TANC",
    link: "/mens-field-watches",
    text: "Shop Field Watches",
    title: "Men's 40mm Field Watch - Steel Case, Black Dial, Tan Leather",
  },
  {
    folder: "JWAT02-38-STBL-STS",
    link: "mens-sport-watches",
    text: "Shop Sport Watches",
    title: "Men's 38mm Sport Watch - Steel Case, Blue Dial, Steel Link",
  },
]
